
import { blogPostsApi, categoriesApi, uploadApi } from "@/integrations/mysql/client";
import { BlogPost, BlogPostFormData, BlogCategory } from "@/types/blogPost";

export const fetchBlogPosts = async (): Promise<BlogPost[]> => {
  return blogPostsApi.list({}) as Promise<BlogPost[]>;
};

export const fetchPublishedBlogPosts = async (): Promise<BlogPost[]> => {
  return blogPostsApi.list({ published: true }) as Promise<BlogPost[]>;
};

export const fetchFeaturedBlogPost = async (): Promise<BlogPost | null> => {
  const post = await blogPostsApi.featured();
  return (post as BlogPost | null);
};

export const fetchBlogPostsByCategory = async (categoryId: string): Promise<BlogPost[]> => {
  return blogPostsApi.list({ published: true, category_id: categoryId }) as Promise<BlogPost[]>;
};

export const fetchRelatedBlogPosts = async (postId: string, categoryId: string, limit: number = 3): Promise<BlogPost[]> => {
  return blogPostsApi.list({ published: true, category_id: categoryId, exclude_id: postId, limit }) as Promise<BlogPost[]>;
};

export const fetchBlogCategories = async (): Promise<BlogCategory[]> => {
  return categoriesApi.list() as Promise<BlogCategory[]>;
};

export const createBlogPost = async (formData: BlogPostFormData): Promise<void> => {
  await blogPostsApi.create({
    title: formData.title,
    subtitle: formData.subtitle,
    content: formData.content,
    content_formatted: formData.content_formatted,
    excerpt: formData.excerpt,
    featured_image_url: formData.featured_image_url,
    category_id: formData.category_id,
    published: formData.published,
    scheduled_for: formData.scheduled_for,
    is_featured: false,
    author_id: '',
    created_at: '',
    updated_at: '',
  });
};

export const updateBlogPost = async (postId: string, formData: BlogPostFormData): Promise<void> => {
  await blogPostsApi.update(postId, {
    title: formData.title,
    subtitle: formData.subtitle,
    content: formData.content,
    content_formatted: formData.content_formatted,
    excerpt: formData.excerpt,
    featured_image_url: formData.featured_image_url,
    category_id: formData.category_id,
    published: formData.published,
    scheduled_for: formData.scheduled_for,
  });
};

export const deleteBlogPost = async (postId: string): Promise<void> => {
  await blogPostsApi.delete(postId);
};

export const uploadBlogImage = async (file: File): Promise<string> => {
  return uploadApi.image(file);
};
